import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpIAPI_CON003 } from "./api/request";
import { funBodyList } from "./hooks/useHooks";
import { headList } from "../SCRW070002/parts";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkTitle from "../../components/atoms/TkTitle";

/**
 * SCRW070002　申請情報詳細（職員情報）一覧
 * @returns JSX.Element
 */
const SCRW070002 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const [applicationStatus, setApplicationStatus] = useState<any>();

  const handleInit = async () => {
    // 申請職員名簿一覧参照API 呼び出し
    try {
      const res = await httpIAPI_CON003({
        contractorNo:
          locationState?.contractorNo ?? businessState.common?.contractorNo,
        applyId: locationState?.applyId ?? businessState.job_01?.applyId,
        facilityNo: locationState?.facilityNo,
      });

      if (res.resultCd === "I0000") {
        setBusinessState({
          ...businessState,
          job_01: {
            applyId: locationState?.applyId,
          },
        });

        setApplicationStatus(res.latestApplyStatus);

        // レスポンスの値からコンポーネント形に変更
        let bodyList = funBodyList(res);
        setBodyList(bodyList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRW070002" data-testid="SCRW070002PageForTest">
      <TkKikoStepper
        applicationFlowType="TYPE1"
        businessType={businessState.common?.businessType}
        applicationStatus={applicationStatus}
        corporateApplicationClassification={
          businessState.job_01?.corpApplyKbn as any
        }
      />

      <TkContractorAndNumberLine
        name={"契約者（法人）名"}
        no={
          (locationState?.contractorNo ?? "") +
          ":" +
          (locationState?.contractorName ?? "")
        }
      />

      <TkTitle size="medium">
        {(locationState?.facilityNo ?? "") +
          ":" +
          (locationState?.facilityName ?? "") +
          "　施設種類 " +
          (locationState?.facilityKind ?? "")}
      </TkTitle>

      <TkTable pagin headList={headList} bodyList={bodyList} />

      <Box className="tkBottonBox">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRW070002;
